// extracted by mini-css-extract-plugin
module.exports = {"accentButton":"AccentButton_accentButton__1Piwk"};